export const COOKIE_CONSENTIMENTO_NOME = 'meuacertocookies';

const DOMINIO_ACERTO = 'acerto.com.br';

export interface ConsentimentoArmazenado {
  popup?: boolean;
  ativo?: boolean;
}

/**
 * Um ano de validade para o cookie de consentimento.
 */
export function calcularExpiracaoConsentimento(agora: Date): Date {
  const expiracao = new Date(agora);
  expiracao.setFullYear(expiracao.getFullYear() + 1);
  return expiracao;
}

/**
 * Em acerto.com.br o cookie vai para o domínio pai, para o consentimento valer em todos os
 * subdomínios Acerto. Fora dele (white label Inter, localhost) o navegador recusa um `domain`
 * alheio, então o cookie precisa ser host-only (`null`).
 */
export function resolverDominioCookie(hostname: string): string | null {
  const ehDominioAcerto = hostname === DOMINIO_ACERTO || hostname.endsWith(`.${DOMINIO_ACERTO}`);
  return ehDominioAcerto ? `.${DOMINIO_ACERTO}` : null;
}

/**
 * Decide o próximo estado do consentimento a partir do cookie (fonte da verdade, pois expira
 * em 1 ano) e do valor hoje salvo em storage. O consentimento é opt-in (LGPD): enquanto o
 * usuário não escolhe, `ativo` é `false` e nenhuma ferramenta de medição carrega.
 * - cookie já decidido -> sincroniza o storage e não exibe popup;
 * - storage com escolha já feita (popup fechado) -> mantém;
 * - qualquer outro caso -> exibe popup, sem consentimento. Inclui o `{ popup: true, ativo: true }`
 *   gravado por versões anteriores, que presumiam o aceite antes do clique.
 */
export function resolverConsentimento(
  cookieValue: string | undefined,
  armazenado: ConsentimentoArmazenado
): ConsentimentoArmazenado {
  if (cookieValue === 'true' || cookieValue === 'false') {
    return { popup: false, ativo: cookieValue === 'true' };
  }

  if (armazenado.popup === false) {
    return armazenado;
  }

  return { popup: true, ativo: false };
}

export function isConsentimentoConcedido(consentimento: ConsentimentoArmazenado): boolean {
  return consentimento.popup === false && consentimento.ativo === true;
}
